import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';

const SoftButton = styled.button`
  align-items: center;
  background: ${props => props.background || Theme.softButtonBackground};
  border: 0;
  border-radius: ${props => props.borderRadius || '4px'};
  color: ${props => props.color || '#333'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  display: inline-flex;
  font-family: inherit;
  font-size: ${props => props.fontSize || '11px'};
  font-weight: ${props => props.fontWeight || 400};
  height: ${props => props.height};
  justify-content: center;
  letter-spacing: ${props => props.letterSpacing || '0.04em'};
  line-height: ${props => props.lineHeight};
  margin: ${props => props.margin || '0 5px 0 0'};
  padding: ${props => props.padding || '0 12px'};
  text-align: center;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.65);
  text-transform: ${props => props.textTransform || 'uppercase'};
  user-select: none;
  white-space: nowrap;
  &:hover {
    background: ${props => props.disabled ? props.background || Theme.softButtonBackground : props.hoverBackground || Theme.softButtonBackgroundOnHover};
  }
`;

export default SoftButton;
